import React from 'react';
import { useRequestDetails, useComments } from '../../../../hooks';
import { FormSectionsCustomer, FormSectionsNonCustomer } from './components';

// Main FormSections component
const FormSections = ({
  subForms,
  requestProgressId,
  persona,
  requestId,
  filledForm,
  requestProgress,
  children,
  handleAction,
  isReadOnly = false,
  roleName,
  // Additional props for advanced use cases
  editable = false,
  onFormDataChange = null,
  syncFormSectionsData = null,
  skipApprovalFetch = false,
  errors = null,
  activeTab = null,
  onTabChange = null,
  showRequestBadges = true,
  enableAddComment = true,
  formName = null,
  setComments = () => {},
  registerSendbackBaseline = () => {},
  hasHcpLicensesList = false,
  isSendbackMode = false,
  skipCommentsFetch = false,
  externalComments = null,
  customFormsData = null,
  hcpProfileMenuEnabled = false,
  hcpProfileMainMenuTabs = null,
  renderHcpProfileMenuContent = null,
  enableProfileSectionAddComment = null,
}) => {
  const requestDetails = useRequestDetails(requestId, persona) || {};

  const {
    prevComments: fetchedComments,
    handleAddComment,
    loadingComments,
  } = useComments({
    persona,
    requestId,
    skipInitialFetch: skipCommentsFetch,
  });

  const prevComments =
    skipCommentsFetch && externalComments !== null
      ? externalComments
      : fetchedComments;

  const commonProps = {
    subForms,
    requestProgressId,
    prevComments,
    requestDetails: customFormsData
      ? { ...requestDetails, ...customFormsData }
      : requestDetails,
    requestId,
    filledForm,
    handleAddComment,
    requestProgress,
    children,
    handleAction,
    roleName,
    formName,
    persona,
    editable,
    onFormDataChange,
    syncFormSectionsData,
    skipApprovalFetch,
    errors,
    activeTab,
    onTabChange,
    showRequestBadges,
    enableAddComment,
    hasHcpLicensesList,
    isSendbackMode,
    setComments,
    registerSendbackBaseline,
    loadingComments,
    hcpProfileMenuEnabled,
    hcpProfileMainMenuTabs,
    renderHcpProfileMenuContent,
    enableProfileSectionAddComment,
  };

  if (persona === 'enduser') {
    return <FormSectionsCustomer {...commonProps} isReadOnly={isReadOnly} />;
  }

  return <FormSectionsNonCustomer {...commonProps} />;
};

export default FormSections;
